import navigation from "../data/navigation.json";

let initialState = {
  items: navigation,
  open: false,
  unlocked: localStorage.getItem('unlocked') === "true",
  showComingSoon: navigation.children[1].comingSoon
};

export default function(state = initialState, action){

  switch(action.type){
    case "navigation/CLOSE":
      return {
        ...state,
        open: false
      };
    case "navigation/OPEN":
      return {
        ...state,
        open: true
      };
    case "navigation/UNLOCK":
      localStorage.setItem('unlocked', "true");
      return {
        ...state,
        unlocked: true
      };
    case "navigation/LOCK":
      localStorage.setItem('unlocked', "false");
      return {
        ...state,
        unlocked: false
      };

    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js